const baseURL = 'https://api.hillgroup.shop'


export default baseURL;